import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { FormGroup } from '../../../../ui/gzForm/formGroup/form-group';
import { CompanyAuthenticationFormController } from '../controller/CompanyAuthenticationFormController';
import { MyCompanyAuthenticationData } from '../../../types/company-data';

export class CompanyAuthenticationFormWebComponent extends BaseWebComponentElement {
  public controller!: CompanyAuthenticationFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: CompanyAuthenticationFormController,
    });
  }

  public getFormGroup(): FormGroup {
    return this.controller.view.formGroup;
  }

  public setFormValue(data: MyCompanyAuthenticationData): void {
    this.controller.canShow2FaDialog = false;
    this.controller.view.setFormValue(data);
    this.controller.canShow2FaDialog = true;

    this.updateCachedFields();
  }

  public hasRemovedSsoProvider() {
    return this.controller.hasRemovedSsoProvider();
  }

  public showIdentityProviderConfirmationWindow(confirmCallback) {
    this.controller.showIdentityProviderConfirmationWindow(confirmCallback);
  }

  public updateCachedFields(): void {
    return this.controller.updateCachedFields();
  }

  public refreshInitialFormValue(): void {
    this.controller.view.formGroup?.refreshInitialFormValue();
  }

  public get initialTwoFactorAuthCheckboxValue() {
    return this.controller.view.dom.$twoFactorAuthCheckbox.value;
  }

  public set canShow2FaDialog(value: boolean) {
    this.controller.canShow2FaDialog = value;
  }

  public setFormGroupToDisabled() {
    this.controller.view.setFormGroupToDisabled();
  }

  public get hasUnsavedChanges(): boolean {
    return this.controller.view.formGroup.hasUnsavedChanges;
  }
}
